/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ICipBusinessSignUp containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum prospectType {
    selectable = 'selectable',
    buyer = 'buyer',
    seller = 'seller'
}

export interface ICipBusinessSignUpConfig extends Msdyn365.IModuleConfig {
    heading: IHeadingData;
    disclaimer?: Msdyn365.RichText;
    confirmationLink: IConfirmationLinkData;
    className?: string;
    clientRender?: boolean;
    prospectType?: prospectType;
}

export interface ICipBusinessSignUpResources {
    prospectTypeLabel: string;
    prospectTypeBuyerLabel: string;
    prospectTypeSellerLabel: string;
    firstNameLabel: string;
    firstNameMaxLength: string;
    salutationLabel: string;
    lastNameLabel: string;
    languageSelectLabel: string;
    lastNameMaxLength: string;
    emailAddressLabel: string;
    phoneLabelText: string;
    phoneMaxLength: string;
    companyLabel: string;
    companyMaxLength: string;
    companyAddressLabel: string;
    companyAddressMaxLength: string;
    jobTitleLabel: string;
    jobTitleMaxLength: string;
    departmentLabel: string;
    departmentMaxLength: string;
    companySizeLabel: string;
    companySizeMaxLength: string;
    commentLabel: string;
    commentMaxLength: string;
    errorMessage: string;
    signUpButtonText: string;
    signUpButtonArialabel: string;
    cancelButtonText: string;
    cancelButtonArialabel: string;
    requiredFieldMissingSummaryError: string;
    requiredFieldMissingError: string;
    vatLabel: string;
    vat: string;
    vatValidateButton: string;
    vatRevalidateButton: string;
    withoutVatCheckbox: string;
    countrySelect: string;
    companyTypeLabel: string;
    additionalAddressLabel: string;
    emailSectionHeader: string;
    emailSectionHeaderLabel: string;
    vatIdSectionHeader: string;
    vatIdSectionHeaderLabel: string;
    personalSectionHeader: string;
    personalSectionHeaderLabel: string;
    companySectionHeader: string;
    companySectionHeaderLabel: string;
    conditionsSectionHeader: string;
    exisitingCustomerNumberLabel: string;
    verifyEmailLabel: string;
    streetLabel: string;
    numberLabel: string;
    zipLabel: string;
    cityLabel: string;
    vatIdValid: string;
    vatIdNotValid: string;
    continueWithoutVatOrValidate: string;
    youWillBeChargedVat: string;
    uncheckToContinueWithValidVat: string;
    emailVerified: string;
    emailVerificationFailed: string;
    verificationPending: string;
    isUserExisting: string;
    emailCodeHasBeenSent: string;
    verifyEmailCodeLabel: string;
    select: string;
    sendEmailVerificationLabel: string;
    confirmEmailCodeButtonLabel: string;
    vatIdFailed: string;
    termsAndConditions: string;
    termsAndConditionsValidate: string;
    signInLinkText: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface IConfirmationLinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface ICipBusinessSignUpProps<T> extends Msdyn365.IModule<T> {
    resources: ICipBusinessSignUpResources;
    config: ICipBusinessSignUpConfig;
    slots: {
        addressSlot: React.ReactNode[];
        languageSlot: React.ReactNode[];
    };
}
